import { get3PLClients } from '../api/fulfillment-delegation';
import { ClientStatus } from './constants';

const getActiveClients = (client) => client.status === ClientStatus.ACTIVE;
const getInactiveClients = (client) => client.status === ClientStatus.INACTIVE;

export const getClientsDataAsync = async (fetchInactiveClients = true) => {
  const clients = [];
  const pendingClients = [];
  let errorFetchingClients = false;

  await get3PLClients(fetchInactiveClients)
    .then((response) => {
      const connectedClients = response?.data?.clients?.sort() ?? []; // alphasort
      clients.push(...connectedClients);

      const pendingInvitations = response?.data?.pendingInvitations?.reverse() ?? []; // reverse-chron
      pendingClients.push(...pendingInvitations);
    })
    .catch(() => {
      errorFetchingClients = true;
    });

  const response = {
    activeClients: clients.filter(getActiveClients),
    inactiveClients: fetchInactiveClients ? clients.filter(getInactiveClients) : undefined,
    pendingClients,
    errorFetchingClients,
  };

  return response;
};
